import React, { useContext, useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import api from "../api";

const Navbar = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [perfil, setPerfil] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      const fetchPerfil = async () => {
        try {
          const response = await api.get("/usuarios/me");
          setPerfil(response.data.perfil); // Recupera o perfil do usuário
        } catch (error) {
          console.error("Erro ao buscar perfil do usuário:", error);
        }
      };

      fetchPerfil();
    }
  }, [isAuthenticated]);

  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);
  };

  const menuItems = [
    { text: "Meu Perfil", path: "/profile", visible: true },
    {
      text: "Usuários",
      path: "/usuarios",
      visible: perfil === "ADMINISTRADOR",
    },
    {
      text: "Parametrização",
      path: "/parametrizacao",
      visible: perfil === "ADMINISTRADOR",
    },
    { text: "Indicadores", path: "/indicadores/dashboard", visible: true },
    { text: "Sair", action: logout, visible: true },
  ];

  return (
    <>
      <AppBar position="static" sx={{ mb: 2 }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            CNCG
          </Typography>
          {isAuthenticated && (
            <>
              {/* Botão de Hamburger para telas pequenas */}
              <Box sx={{ display: { xs: "block", md: "none" } }}>
                <IconButton
                  color="inherit"
                  edge="start"
                  onClick={() => toggleDrawer(true)}
                >
                  <MenuIcon />
                </IconButton>
              </Box>
              {/* Botões do Navbar para telas maiores */}
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                {menuItems
                  .filter((item) => item.visible)
                  .map((item, index) => (
                    <Button
                      key={index}
                      color="inherit"
                      onClick={
                        item.action ? item.action : () => navigate(item.path)
                      }
                    >
                      {item.text}
                    </Button>
                  ))}
              </Box>
            </>
          )}
        </Toolbar>
      </AppBar>
      {/* Drawer para o menu lateral */}
      {isAuthenticated && (
        <Drawer
          anchor="left"
          open={isDrawerOpen}
          onClose={() => toggleDrawer(false)}
        >
          <Box sx={{ width: 250 }} role="presentation">
            <List>
              {menuItems
                .filter((item) => item.visible)
                .map((item, index) => (
                  <ListItem
                    button
                    key={index}
                    onClick={() => {
                      if (item.path) navigate(item.path);
                      if (item.action) item.action();
                      toggleDrawer(false);
                    }}
                  >
                    <ListItemText primary={item.text} />
                  </ListItem>
                ))}
            </List>
          </Box>
        </Drawer>
      )}
    </>
  );
};

export default Navbar;
